import { REQUEST, SUCCESS, FAILURE } from 'Redux/actions/constants'

import { FETCH_LEAD_PROFILE_API } from './actions'

const initialState = {
  leadProfile: null,
  isFetchingLeadProfile: false,
}


const alertSharedReducer = (state = initialState, action) => {
  switch(action.type) {
    case FETCH_LEAD_PROFILE_API[REQUEST]:
      return {
        ...state,
        isFetchingLeadProfile: true,
      }
    case FETCH_LEAD_PROFILE_API[SUCCESS]:
      const lead = action.response
      return {
        ...state,
        leadProfile: lead,
        isFetchingLeadProfile: false,
      }
    case FETCH_LEAD_PROFILE_API[FAILURE]:
      return {
        ...state,
        isFetchingLeadProfile: false,
      }
  }
  return state
}


export default alertSharedReducer

